/* eslint-disable eqeqeq */
import i18n from '@i18n';
import isNumeric from '@/common/isNumeric';
/**
 uprava score pre potreby half-time a extra score, prip. na specificke sporty ako bejzbal a snooker
 napr. futbal 1. polcas, 2. polcas, extra (predlzenie, penaulty, ...),
 ale napr. basketbal 1. stvrtina, 2. stvrtina, polcas, 3. stvrtina, 4. stvrtina, extra (predlzenie)
 */

export function scoreForSport(periodScores, sportId, basketballMatchType) {
    const score = function(upScore) {
        let home = 0;
        let away = 0;
        const score = [];
        if (typeof periodScores !== 'undefined' && periodScores !== null && periodScores.length > upScore) {
            for (let i = 0; i < periodScores.length; i++) {
                if (i < upScore) {
                    score[i] = periodScores[i];
                } else {
                    home += parseInt(periodScores[i].score.home);
                    away += parseInt(periodScores[i].score.away);
                }
            }
            score[upScore] = {
                period: {
                    code: 'ex',
                    nameShortened: i18n('jsp.liveStavky.detailPodujatia.ex')
                },
                score: {
                    away: away,
                    home: home
                }
            };
            return score;
        }
        return periodScores;
    };

    function scoreBasketbal() {
        let home = 0;
        let away = 0;
        const score = [];
        let j = 0;
        if (typeof periodScores !== 'undefined' && periodScores !== null && periodScores.length > 2) {
            for (let i = 0; i < periodScores.length; i++) {
                score[j] = periodScores[i];
                if (i < 2) {
                    home += parseInt(periodScores[i].score.home);
                    away += parseInt(periodScores[i].score.away);
                }
                if (i == 2) {
                    score[j] = {
                        period: {
                            code: 'halftime',
                            nameShortened: i18n('jsp.liveStavky.detailPodujatia.polcas')
                        },
                        score: {
                            away: away,
                            home: home
                        }
                    };
                    j++;
                    score[j] = periodScores[i];
                }
                if (i == 4) {
                    score[j] = {
                        period: {
                            code: 'ex',
                            nameShortened: i18n('jsp.liveStavky.detailPodujatia.ex')
                        },
                        score: {
                            away: periodScores[i].score.away,
                            home: periodScores[i].score.home
                        }
                    };
                }
                j++;
            }
            return score;
        }
        return periodScores;
    }

    const scoreBejzbal = function() {
        let home = 0;
        let away = 0;
        const score = [];
        if (typeof periodScores !== 'undefined' && periodScores !== null) {
            if (periodScores.length > 9) {
                for (let i = 9; i < periodScores.length; i++) {
                    home += parseInt(periodScores[i].score.home);
                    away += parseInt(periodScores[i].score.away);
                }
                score[0] = periodScores[8];
                score[1] = {
                    period: {
                        code: 'ex',
                        nameShortened: i18n('jsp.liveStavky.detailPodujatia.ex')
                    },
                    score: {
                        away: away,
                        home: home
                    }
                };
            } else {
                score[0] = periodScores[periodScores.length - 1 < 0 ? 0 : periodScores.length - 1];
            }
            return score;
        }
        return periodScores;
    };

    const scoreSnooker = function() {
        const score = [];
        if (typeof periodScores !== 'undefined' && periodScores !== null && periodScores.length > 0) {
            for (let i = periodScores.length - 1; i >= 0; i--) {
                if (isNumeric(periodScores[i].score.home) && isNumeric(periodScores[i].score.away)) {
                    score[0] = periodScores[i];
                    break;
                }
            }
            if (score.length == 0) {
                score[0] = periodScores[0];
            }
            return score;
        }
        return periodScores;
    };

    if (sportId === 1) {
        //futbal
        return score(2);
    } else if (sportId === 3) {
        //hokej
        return score(3);
    } else if (sportId === 5) {
        //basketbal
        if (basketballMatchType === 'NCAA') {
            return score(2);
        } else {
            return scoreBasketbal();
        }
    } else if (sportId === 39) {
        //americky futbal
        return scoreBasketbal();
    } else if (sportId === 59) {
        //bejzbal
        return scoreBejzbal();
    } else if (sportId === 68) {
        //futsal
        return score(2);
    } else if (sportId === 85) {
        //snooker
        return scoreSnooker();
    } else if (sportId === 67) {
        //rugby
        return score(2);
    } else if (sportId === 88) {
        //sipky
        return scoreSnooker();
    } else if (sportId === 62) {
        // vodne polo
        return scoreBasketbal();
    }
    return periodScores;
}
